import { useAuthStore } from "@/features/auth/useAuthStore";
import { ROLES } from "../constants/roles";

/**
 * Returns true only when the copywriter role is the sole role held by the user.
 * Order-insensitive: the result does not depend on the position of the role
 * within the roles claim.
 */
export function userIsCopywriterOnly(): boolean {
  const roles = useAuthStore().userRoles;
  if (!roles || roles.length === 0) return false;
  return roles.every((role) => role === ROLES.COPYWRITER);
}
